"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSchoolFilterSchema = void 0;
const zod_1 = require("zod");
// Схема для IFindSchoolFilter
exports.findSchoolFilterSchema = zod_1.z.object({
  id: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional(),
  owner_id: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional(),
  teacher_id: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional(),
  subject_id: zod_1.z.union([zod_1.z.number(), zod_1.z.array(zod_1.z.number())]).optional(),
  language_id: zod_1.z.union([zod_1.z.number(), zod_1.z.array(zod_1.z.number())]).optional(),
  term: zod_1.z.string().optional(),
  status: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional()
})
// TODO: remove catchall, need to define all fields
.catchall(zod_1.z.any()); // для других полей
